export enum AdminBrandListItemAction {
  Edit,
  Preview,
  Remove,
}
